export default __webpack_public_path__ + "static/media/postTwo.5fcc47f3.jpg";